import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClassroomDetailPageResponse } from '@edtech-ui/core/models/Classroom/classrom-detail-page';
import { CoverImageResponse } from '@edtech-ui/core/models/Classroom/cover-image';
import { CreateClassroomResponse } from '@edtech-ui/core/models/Classroom/create-classroom';
import { DeleteClassroomResponse } from '@edtech-ui/core/models/Classroom/delete-classroom';
import { UpdateClassroomResponse } from '@edtech-ui/core/models/Classroom/edit-classroom';
import { GetAllStudentsResponse, GetStudentsRequest } from '@edtech-ui/core/models/Classroom/get-all-students';
import { GetClassroomResponse } from '@edtech-ui/core/models/Classroom/get-classroom';
import { GetAllCoursesResponse, GetClassroomByTeacherResponse } from '@edtech-ui/core/models/Classroom/get-classroomByTeacher';
import { GetClassroomByNameResponse } from '@edtech-ui/core/models/Classroom/searchClassroom-name';
import { JoinClassPayload, JoinClassResponse } from '@edtech-ui/core/models/members/join-class-code';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, Subject, tap } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ClassroomManagementService {

	apiUrl = environment.classroomApiUrl;
	studentApiUrl = environment.studentApiUrl;
	dashboardApiUrl = environment.dashboardUrl;

	reload$ = new Subject<void>;
	class_code = new BehaviorSubject<string>('');

	constructor(private readonly http: HttpClient) { }

	postCreateClassroom(payload: FormData): Observable<CreateClassroomResponse> {
		return this.http.post<CreateClassroomResponse>(`${this.apiUrl}/createClassroom`, payload).pipe(
			tap(() => this.reload$.next())
		);
	}

	getClassroom(): Observable<GetClassroomResponse> {
		return this.http.get<GetClassroomResponse>(`${this.apiUrl}/getAllClass`);
	}

	deleteClassroom(id: number): Observable<DeleteClassroomResponse<null>> {
		return this.http.delete<DeleteClassroomResponse<null>>(`${this.apiUrl}/deleteClassroom/${id}`).pipe(
			tap(() => this.reload$.next())
		);
	}

	updateClassroom(id: string, data: FormData): Observable<UpdateClassroomResponse> {
		return this.http.patch<UpdateClassroomResponse>(`${this.apiUrl}/updateClassRoom/${id}`, data).pipe(
			tap(() => this.reload$.next())
		);
	}

	postClassroomNameOrSubject(searchParams: { name?: string; subject?: string }): Observable<GetClassroomByNameResponse> {
		return this.http.post<GetClassroomByNameResponse>(`${this.apiUrl}/getClassroomByNameOrSubject`, searchParams);
	}

	getAllTeacherClassrooms(filterType: string, page: number = 1): Observable<GetClassroomByTeacherResponse> {
		const params = {
			filter_type: filterType,
			page: page.toString()
		};
		return this.http.get<GetClassroomByTeacherResponse>(`${this.apiUrl}/getAllTeacherClassroom`, { params });
	}

	getClassroomById(id: string): Observable<ClassroomDetailPageResponse> {
		return this.http.get<ClassroomDetailPageResponse>(`${this.apiUrl}/getClassroom/${id}`);
	}

	getCoverImage(): Observable<CoverImageResponse> {
		return this.http.get<CoverImageResponse>(`${this.apiUrl}/getCoverImg`);
	}

	postJoinClass(payload: JoinClassPayload): Observable<JoinClassResponse> {
		return this.http.post<JoinClassResponse>(`${this.apiUrl}/joinClass`, payload);
	}

	getStudentClassrooms(page: number = 1, pageSize: number = 10): Observable<GetClassroomByTeacherResponse> {
		const params = {
			page: page.toString(),
			page_size: pageSize.toString()
		};
		return this.http.get<GetClassroomByTeacherResponse>(`${this.studentApiUrl}/getAllStudentClassrooms`, { params });
	}

	getCourses(params: {
		page: number;
		page_size: number;
		search?: string | null;
		status_filter?: string | null;
		classroom_filter?: number | null;
	}): Observable<GetAllCoursesResponse> {

		let query = new HttpParams()
			.set('page', params.page.toString())
			.set('page_size', params.page_size.toString())
			.set('search', params.search ?? '')
			.set('status_filter', params.status_filter ?? '');

		if (params.classroom_filter) {
			query = query.set('classroom_filter', params.classroom_filter.toString());
		}

		return this.http.get<GetAllCoursesResponse>(
			`${this.dashboardApiUrl}/courses`,
			{ params: query }
		);
	}
	getAllStudents(params: GetStudentsRequest): Observable<GetAllStudentsResponse> {

		let query = new HttpParams()
			.set('page', params.page.toString())
			.set('page_size', params.page_size.toString())
			.set('search', params.search ?? '');

		if (params.classroom_filter) {
			query = query.set('classroom_filter', params.classroom_filter.toString());
		}
		if (params.department_filter) {
			query = query.set('department_filter', params.department_filter.toString());
		}
		if (params.batch_filter) {
			query = query.set('batch_filter', params.batch_filter.toString());
		}

		return this.http.get<GetAllStudentsResponse>(
			`${environment.dashboardUrl}/students`,
			{ params: query }
		);
	}




}